import React from "react";

import offlineIcon from "../assets/circle-phone-icon.jpg";
import {
  gridPageCountSelector,
  GridPagination,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid";
import dayjs from "dayjs";
import MuiPagination from "@mui/material/Pagination";

export const CustomDataGridPagination = ({ page, onPageChange, className }) => {
  const apiRef = useGridApiContext();
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);

  return (
    <MuiPagination
      color="primary"
      className={className}
      count={pageCount}
      page={page + 1}
      onChange={(event, newPage) => {
        onPageChange(event, newPage - 1);
      }}
    />
  );
};

// Custom Pagination for DataGrid Table
export const DataGridCustomPagination = (props) => {
  return (
    <GridPagination ActionsComponent={CustomDataGridPagination} {...props} />
  );
};

export const DataGridCustomPaginationForPractise = (props) => {
  return (
    <GridPagination ActionsComponent={CustomDataGridPagination} {...props} />
  );
};

export const displayDateFormatter = (date) => {
  // To convert date to mm/dd/yyyy format to display on UI
  if (!date) return null;
  try {
    let newDate = date;
    if (typeof date === "string") newDate = dayjs(date.substring(0, 16));
    return dayjs(newDate).format("MM/DD/YYYY");
  } catch (e) {
    console.log("ERROR", e);
  }
  return null;
};

export const dateFormatter = (date) => {
  if (date) return date;
  else return "";
};

// to fix if date goes back by one day
export const fixDate = (date) => {
  if (!date) return null;
  if (typeof date === "string") return dayjs(date.substring(0, 16)); // Convert string to dayjs object
  return dayjs(date); // Convert date object to dayjs
};

export const isoDateFormatter = (date) => {
  // To convert date to yyyy-mm-dd format
  if (typeof date === "string") date = fixDate(date);
  if (date) return date.format("YYYY-MM-DD"); // Use dayjs's format method
  return null;
};

export const displayTimeFormatter = (time) => {
  // To convert time from
  // hh:mm:ss (24hrs) to hh:mm AM/PM
  if (!time) return null;
  let hr = time.slice(0, 2);
  hr = hr < 12 ? hr : hr - 12;
  const min = time.slice(3, 5);
  const meridiem = parseInt(hr) > 12 ? "PM" : "AM";
  return `${hr}:${min} ${meridiem}`;
};

export const AMPMTime = (date) => {
  console.log("date>>: ", date);
  if (!date) return ""; // Return empty string if no date is provided

  const parsedDate = dayjs(date); // Parse the date using Day.js
  if (!parsedDate.isValid()) return ""; // Check if the date is valid

  // Format the date using Day.js format method
  return parsedDate.format("hh:mm A");
};

export const addMinutes = (time, addMins, isEndTime) => {
  /* 
    @time: string e.g. 3:00 PM
    @minToAdd: number
  */
  const minsToAdd = addMins && addMins !== 0 ? parseInt(addMins) : 15;
  const D = (J) => (J < 10 ? "0" : "") + J;
  let timeArray = time.split(" "); // ['3:00', 'PM']
  let piece = timeArray[0].split(":"); // ['3', '00']
  const hour =
    timeArray[1] === "PM"
      ? parseInt(piece[0]) === 12
        ? 12
        : parseInt(piece[0]) + 12
      : parseInt(piece[0]) === 12
      ? 0
      : parseInt(piece[0]);
  let mins = hour * 60 + +piece[1];
  if (isEndTime) mins += minsToAdd;
  return D(((mins % (24 * 60)) / 60) | 0) + ":" + D(mins % 60);
};

export const StatusCircle = ({ status, offlineType }) => {
  const styles = {
    display: "inline-block",
    width: 14,
    height: 14,
    borderRadius: "51px",
    marginRight: "5px",
    marginTop: "3.5px",
  };
  if (offlineType)
    return (
      <img
        src={offlineIcon}
        width={14}
        height={14}
        alt=""
        style={{ borderRadius: "50%" }}
      />
    );
  switch (status?.toLowerCase()) {
    case "waiting":
      return <div style={{ ...styles, backgroundColor: "#cd9933" }}></div>;
    case "cancellationrequest":
      return <div style={{ ...styles, backgroundColor: "#cd3367" }}></div>;
    case "confirmed":
      return <div style={{ ...styles, backgroundColor: "#33cccc" }}></div>;
    default:
      return null;
  }
};

export const checkStringValue = (data) => {
  if (data) return data;
  return "";
};

export const BackButton = ({ onClick }) => {
  return (
    <button onClick={onClick} className="back-button">
      <svg
        height="16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        viewBox="0 0 1024 1024"
      >
        <path d="M874.690416 495.52477c0 11.2973-9.168824 20.466124-20.466124 20.466124l-604.773963 0 188.083679 188.083679c7.992021 7.992021 7.992021 20.947078 0 28.939099-4.001127 3.990894-9.240455 5.996574-14.46955 5.996574-5.239328 0-10.478655-1.995447-14.479783-5.996574l-223.00912-223.00912c-3.837398-3.837398-5.996574-9.046027-5.996574-14.46955 0-5.433756 2.159176-10.632151 5.996574-14.46955l223.019353-223.029586c7.992021-7.992021 20.957311-7.992021 28.949332 0 7.992021 8.002254 7.992021 20.957311 0 28.949332l-188.073446 188.073446 604.753497 0C865.521592 475.058646 874.690416 484.217237 874.690416 495.52477z"></path>
      </svg>
      <span>Back</span>
    </button>
  );
};

export const displayAddress = ({ address1, address2, city, state, zip }) => {
  const addComma = (value) => (value ? `${value}, ` : "");
  return `${addComma(address1)}${addComma(address2)}${addComma(city)}${
    state ? state + " - " : ""
  }${zip || ""}`;
};

export function componentLoader(lazyComponent, attemptsLeft = 3) {
  return new Promise((resolve, reject) => {
    lazyComponent()
      .then(resolve)
      .catch((error) => {
        // let us retry after 1500 ms
        setTimeout(() => {
          if (attemptsLeft === 1) {
            reject(error);
            return;
          }
          componentLoader(lazyComponent, attemptsLeft - 1).then(
            resolve,
            reject
          );
        }, 1500);
      });
  });
}

export const states = [
  { label: "Alabama", value: "AL" },
  { label: "Alaska", value: "AK" },
  { label: "American Samoa", value: "AS" },
  { label: "Arizona", value: "AZ" },
  { label: "Arkansas", value: "AR" },
  { label: "California", value: "CA" },
  { label: "Colorado", value: "CO" },
  { label: "Connecticut", value: "CT" },
  { label: "Delaware", value: "DE" },
  { label: "Florida", value: "FL" },
  { label: "Georgia", value: "GA" },
  { label: "Guam", value: "GU" },
  { label: "Hawaii", value: "HI" },
  { label: "Idaho", value: "ID" },
  { label: "Illinois", value: "IL" },
  { label: "Indiana", value: "IN" },
  { label: "Iowa", value: "IA" },
  { label: "Kansas", value: "KS" },
  { label: "Kentucky", value: "KY" },
  { label: "Louisiana", value: "LA" },
  { label: "Maine", value: "ME" },
  { label: "Maryland", value: "MD" },
  { label: "Massachusetts", value: "MA" },
  { label: "Michigan", value: "MI" },
  { label: "Minnesota", value: "MN" },
  { label: "Mississippi", value: "MS" },
  { label: "Missouri", value: "MO" },
  { label: "Montana", value: "MT" },
  { label: "Nebraska", value: "NE" },
  { label: "Nevada", value: "NV" },
  { label: "New Hampshire", value: "NH" },
  { label: "New Jersey", value: "NJ" },
  { label: "New Mexico", value: "NM" },
  { label: "New York", value: "NY" },
  { label: "North Carolina", value: "NC" },
  { label: "North Dakota", value: "ND" },
  { label: "Northern Mariana Isla", value: "MP" },
  { label: "Ohio", value: "OH" },
  { label: "Oklahoma", value: "OK" },
  { label: "Oregon", value: "OR" },
  { label: "Pennsylvania", value: "PA" },
  { label: "Puerto Rico", value: "PR" },
  { label: "Rhode Island", value: "RI" },
  { label: "South Carolina", value: "SC" },
  { label: "South Dakota", value: "SD" },
  { label: "Tennessee", value: "TN" },
  { label: "Texas", value: "TX" },
  { label: "Utah", value: "UT" },
  { label: "Vermont", value: "VT" },
  { label: "Virgin Islands", value: "VI" },
  { label: "Virginia", value: "VA" },
  { label: "Washington", value: "WA" },
  { label: "Washington D.C.", value: "DC" },
  { label: "West Virginia", value: "WV" },
  { label: "Wisconsin", value: "WI" },
  { label: "Wyoming", value: "WY" },
];

export const timeZoneArray = ["EST", "CST"];

export const dayNightTimeArray = [
  "00:00",
  "00:15",
  "00:30",
  "00:45",
  "01:00",
  "01:15",
  "01:30",
  "01:45",
  "02:00",
  "02:15",
  "02:30",
  "02:45",
  "03:00",
  "03:15",
  "03:30",
  "03:45",
  "04:00",
  "04:15",
  "04:30",
  "04:45",
  "05:00",
  "05:15",
  "05:30",
  "05:45",
  "06:00",
  "06:15",
  "06:30",
  "06:45",
  "07:00",
  "07:15",
  "07:30",
  "07:45",
  "08:00",
  "08:15",
  "08:30",
  "08:45",
  "09:00",
  "09:15",
  "09:30",
  "09:45",
  "10:00",
  "10:15",
  "10:30",
  "10:45",
  "11:00",
  "11:15",
  "11:30",
  "11:45",
  "12:00",
  "12:15",
  "12:30",
  "12:45",
  "13:00",
  "13:15",
  "13:30",
  "13:45",
  "14:00",
  "14:15",
  "14:30",
  "14:45",
  "15:00",
  "15:15",
  "15:30",
  "15:45",
  "16:00",
  "16:15",
  "16:30",
  "16:45",
  "17:00",
  "17:15",
  "17:30",
  "17:45",
  "18:00",
  "18:15",
  "18:30",
  "18:45",
  "19:00",
  "19:15",
  "19:30",
  "19:45",
  "20:00",
  "20:15",
  "20:30",
  "20:45",
  "21:00",
  "21:15",
  "21:30",
  "21:45",
  "22:00",
  "22:15",
  "22:30",
  "22:45",
  "22:00",
  "22:15",
  "22:30",
  "22:45",
  "23:00",
  "23:15",
  "23:30",
  "23:45",
];

export const daysArray = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

export const keysArray = [
  "forward_practice_phone",
  "forward_billing_phone",
  "practice_orcicare_ans_serv_n",
  "forward_number",
  "billing_number",
  "provider_npi",
  "primary_practice_number",
];

export const contactArray = ["Phone", "Email"];

export const patientStatusArray = [
  "Spoke to Patient",
  "Unable to Reach",
  "Left voicemail",
  "Invalid Number",
];

export const statusArray = ["ACTIVE", "INACTIVE"];

export const offlineConsultationArray = ["Y", "N"];

export const getEnv = () => {
  const host = window.location.host.split(":")[0];
  if (host === "provider-web-test.services.orcicare.com") {
    return "prod";
  }
  if (host === "provider-web.services.orcicare.com") {
    return "test";
  }
  return "local";
};

export const open_billing_charge_entry = ({ patient_id, charge_entry_id }) => {
  if (!patient_id || !charge_entry_id) return;
  const params = `charge-entry/${patient_id}/${charge_entry_id}`;
  const env = getEnv();
  if (env === "prod") {
    window.open(
      "https://billing-web.services.orcicare.com/" + params,
      "_blank"
    );
  } else if (env === "test") {
    window.open(
      "https://billing-web-test.services.orcicare.com/" + params,
      "_blank"
    );
  } else {
    window.open("http://localhost:3000/" + params, "_blank");
  }
};

export const colorArray = [
  "#9B9B7A",
  "#D9AE94",
  "#F1DCA7",
  "#FFCB69",
  "#D08C60",
  "#997B66",
  "#9B9B7A",
  "#D9AE94",
  "#F1DCA7",
  "#FFCB69",
  "#D08C60",
  "#997B66",
  "#9B9B7A",
  "#D9AE94",
  "#F1DCA7",
  "#FFCB69",
  "#D08C60",
  "#997B66",
  "#9B9B7A",
  "#D9AE94",
  "#F1DCA7",
  "#FFCB69",
  "#D08C60",
  "#997B66",
  "#9B9B7A",
  "#D9AE94",
  "#F1DCA7",
  "#FFCB69",
  "#D08C60",
  "#997B66",
];

export const displayCost = (number) => {
  if (!number && number !== 0) return "N/A";
  if (typeof number === "string") number = parseFloat(number);
  if (isNaN(number)) return "--";
  const num = number || 0;
  const options = {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  };
  const cost = Number(num).toLocaleString("en", options);
  return "$ " + cost;
};
